import CookieUtils from './CookieUtils';
export default class CSRFUtils {
    static getCSRFToken() {
        let csrfToken = null;
        // For local dev we don't support https at the moment.
        // So we need to remove the cookie prefix to allow things to run.
        if (process.env.NODE_ENV === 'production') {
            csrfToken = CookieUtils.getCookie(CSRFUtils.CSRF_TOKEN_COOKIE_NAME);
        }
        else {
            csrfToken = CookieUtils.getCookie(CSRFUtils.CSRF_TOKEN_COOKIE_NAME_WITHOUT_PREFIX);
        }
        return csrfToken;
    }
}
CSRFUtils.CSRF_TOKEN_HEADER_NAME = "X-Csrf-Token";
CSRFUtils.CSRF_TOKEN_COOKIE_NAME_WITHOUT_PREFIX = "CSRF";
CSRFUtils.CSRF_TOKEN_COOKIE_NAME = "__Host-CSRF";
//# sourceMappingURL=CSRFUtils.js.map